module.exports = __webpack_public_path__ + "static/media/RScollageWithTitle.1b26ea84.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/press/RScollageWithTitle.jpg
// module id = 195
// module chunks = 0